import { ILaneRateCard, TSettingsRateCardType } from '@types';

export const getRateCardIndex = ({
	rateCardSettingsTypes,
	rateCardTypes,
	itemTypeId,
	isSettings,
	type,
}: {
  rateCardSettingsTypes: TSettingsRateCardType[];
  rateCardTypes: ILaneRateCard[];
  itemTypeId?: string;
  isSettings: boolean;
  type?: string;
}) => {
	const rcTypeAtom = isSettings ? rateCardSettingsTypes : rateCardTypes;
	const index = rcTypeAtom.findIndex((rateCard) => {
		return (
			(itemTypeId && rateCard.item_type_id === itemTypeId) ||
			(!itemTypeId && rateCard.type === type)
		);
	});

	return String(index);
}